const clientTestimonials = {
  displayField: 'header',
  name: 'Client Testimonials',
  description: '',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'testimonials',
      name: 'Testimonials',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'testimonial' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'clientTestimonials',
    version: 7,
    updatedAt: '2023-08-02T21:20:00.978Z'
  }
};
export default clientTestimonials;